import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { useDispatch, useSelector } from 'react-redux'
import { selectHeaderTabDS, selectTransactionNatureList, selectValuationMethodList } from '@EUForms/selectors'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { useEvent } from '@hooks/useEvent'
import { itemActions } from '../../../reducer/ItemSlice'
import { saveMassUpdateData } from '../../../../../commonApis/saveEvents'
import { showToast } from '@commonComponents/showToast'
import { useTranslation } from '@hooks/useTranslation'
import { addExtraSpace } from '@EUForms/utils'

export const InvoiceHeader = React.memo(
  ({
    dataSource: {
      totalPackages,
      totalGrossMass,
      totalNetMass,
      totalInvoiceAmount,
      totalInvoiceAmountInCurrency,
      valuationMethod,
      natureOfTransaction,
    }
  }) => {
    const dispatch = useDispatch()
    const { isDisabled } = useCurrentShipmentType()
    const disabled = true;
    const translate = useTranslation()
    const { isImportShipment } = useCurrentShipmentType()
    const procedure = useSelector(selectHeaderTabDS)?.procedure
    const natureOfTransactionList = useSelector(selectTransactionNatureList)
    const invoiceDataList = useSelector(state => state.invoiceReducer.invoice.invoiceIdList)
    const valuationMethodList = useSelector(selectValuationMethodList)
    const { saveForm } = useEvent('invoiceTab')
    const { updateInvoiceUpperHeader, massUpdateAtMultiInvoiceLevel } = itemActions

    const massUpdateAtShipmentLevel = async (name, value) => {
      const response = await saveMassUpdateData('UPDATE_ALL_ITEMS_EU', {
        lineItem: { [`${name}`]: value },
        countryCode: 'NL'
      })
      if (response?.data?.eventMessage?.responseCode == '200') {
        dispatch(massUpdateAtMultiInvoiceLevel({
          invoiceIds: invoiceDataList,
          data: { [`${name}`]: value }
        }))
      } else showToast(translate('SOMETHING_WENT_WRONG'))
    }

    const onSelect = useCallback(
      async (e, { value, name }) => {
        dispatch(updateInvoiceUpperHeader({ [name]: value?.trim() }))
        saveForm({ invoiceUpperHeader: addExtraSpace({ [name]: value }) })
        if (!!value && (name === 'natureOfTransaction' || name === 'valuationMethod')){
          await massUpdateAtShipmentLevel(name, value)
        }        
      },
      [updateInvoiceUpperHeader, saveForm]
    )

    return (
      <Grid className='responsiveGridCss'>
        <Grid.Row>
          <Grid.Column>
            <InputField
              id={`Packages`}
              type='text'
              label='PACKAGES'
              value={totalPackages}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <InputField
              id={`GrossKg`}
              type='text'
              label='GROSS_KG'
              value={totalGrossMass}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <InputField
              id={`NetKg`}
              type='text'
              label='NET_KG'
              value={totalNetMass}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column>
            <InputField
              id="totalInvoiceAmountInCurrency"
              type='text'
              label='TOTAL_INVOICE_VALUE_IN_CURR'
              value={totalInvoiceAmountInCurrency}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          <Grid.Column>
            <InputField
              id="totalInvoiceValueInEur"
              type='text'
              label='TOTAL_INVOICE_VALUE_IN_EUR'
              value={totalInvoiceAmount}
              clearInput={false}
              isDisabled={disabled}
            />
          </Grid.Column>
          {isImportShipment && (
            <Grid.Column>
              <DropDown
                id='valuationMethod'
                name='valuationMethod'
                label='VALUATION_METHOD'
                labelClass='text-none'
                boxNumber='4/16'
                data={valuationMethodList}
                text={valuationMethod}
                value={valuationMethod}
                clearable
                isDisabled={isDisabled}
                onChange={onSelect}
              />
            </Grid.Column>
          )}
          <Grid.Column>
            <DropDown
              id='natureOfTransaction'
              label='NATURE_OF_TRANSACTION'
              labelClass='text-none'
              boxNumber='8/5'
              direction='left'
              data={natureOfTransactionList}
              value={natureOfTransaction}
              text={natureOfTransaction}
              name='natureOfTransaction'
              isDisabled={isDisabled || procedure === 'B3'}
              onChange={onSelect}
              clearable
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
)

